/*
================================================
Une mixin pour pour diverses fonctions de manipulation de temps
================================================
*/

var TimeMixin = {
    // created() {
    // },

    // data: function () {
    //     return {}
    // },
    methods: {

        /**
         * Calcule une durée entre 2 dates (au format moment duration)
         *
         * https://momentjs.com/docs/#/durations/
         * inspiré de https://stackoverflow.com/questions/18623783/get-the-time-difference-between-two-datetimes
         * @param moment $moment
         * @param timeIn (format 2019-05-19T07:17:11+00:00)
         * @param timeOut (format 2019-05-19T07:17:11+00:00)
         * @returns Retourne un objet Duration (la durée en millisecondes est accessible dans la prop "_milliseconds")
         */
        calculateDuration: function(moment,timeIn,timeOut){
            let ms = moment(timeOut).diff(timeIn);
            return moment.duration(ms);
        },


        /**
         * Format une objet moment Duration pour un affichage humain
         * (exemple 3h 40min, 34 sec, 28 min). Utilise moment-duration-format
         *
         * @param duration Un objet Duration moment (https://momentjs.com/docs/#/durations/)
         * @param moment $moment
         * @returns {string}
         */
        formatDuration: function (duration, moment, locale) {
            let template = Array(['fr'],['en']);

                    //si les jours et heures sont différentes de 0 on masque les minutes et sec -> 1j 2h
                    if (duration._data.days != 0 && duration._data.hours != 0)  {
                        template['fr'] =  " d [j] h [h]";
                        template['en'] =  " d [d] h [h]";
                    }
                    //si les heures et minutes sont différentes de 0 on masque les secondes -> 4h 34m
                    else if (duration._data.hours != 0 && duration._data.minutes != 0)  {
                        template['fr'] =  " d [j] h [h] m [m]";
                        template['en'] =  " d [d] h [h] m [m]";
                    }

                    else {
                        // si que minutes et secondes ->on affiche "m" et "s" au lieu de "min" et "sec" -> 4m 45s
                        if (duration._data.days == 0 && duration._data.hours == 0 &&
                            duration._data.minutes != 0 && duration._data.seconds != 0) {


                            // NOTE : ici je laisse les jours et heures bien que vide car  moment-duration-format gère la suppression si vide
                            template['fr'] =  "d [j] h [h] m [m] s [s]";
                            template['en'] =  "d [d] h [h] m [m] s [s]";
                        }

                        // si seconde vide on affiche "min" -> 43min
                        else if (duration._data.seconds == 0) {
                            // NOTE : ici je laisse les secondes bien que vide car  moment-duration-format gère la suppression si vide

                            template['fr'] = "d [j] h [h] m [min] s [s]";
                            template['en'] = "d [d] h [h] m [min] s [s]";
                        }

                        else {
                            // format par défaut pour les autres cas
                            template['fr'] =  "d [j] h [h] m [m] s [sec]";
                            template['en'] =  "d [d] h [h] m [m] s [sec]";
                        }

                    }

            return moment.duration(duration).format(
                template[locale],
                {
                    trim: 'both mid',  //stratégie de trim https://www.npmjs.com/package/moment-duration-format#template
                    usePlural: false,
                    round: false
                });
        },

        /**
         * Format une objet moment Duration pour un affichage humain en nombre d'heure (même si dépasse 23h)
         * (exemple 456h). Utilise moment-duration-format
         *
         * @param duration Un objet Duration moment (https://momentjs.com/docs/#/durations/)
         * @param moment $moment
         * @returns {string}
         */
        formatDurationInHour: function (duration, moment, locale) {
            let template = Array(['fr'],['en']);

                template['fr'] =  "h [h]";
                template['en'] =  "h [h]";

            return moment.duration(duration).format(
                template[locale],
                {
                    usePlural: false,
                    round: false
                });
        },

        /**
         * Format une objet moment Duration pour un affichage en nombre de secondes
         * (exemple 3600s). Utilise moment-duration-format
         *
         * @param duration Un objet Duration moment (https://momentjs.com/docs/#/durations/)
         * @param moment $moment
         * @returns {string}
         */
        formatDurationInSecond: function (duration, moment, locale) {
            let template = Array(['fr'],['en']);

            template['fr'] =  "s [s]";
            template['en'] =  "s [s]";

            return moment.duration(duration).format(
                template[locale],
                {
                    usePlural: false,
                    round: false
                });
        },

        /**
         * Format une objet moment Duration pour un affichage humain en nombre d'heure (même si dépasse 23h)
         * (exemple 456h). Utilise moment-duration-format
         *
         * @param duration Un objet Duration moment (https://momentjs.com/docs/#/durations/)
         * @param moment $moment
         * @returns {string}
         */
        formatDurationInHourAndMin: function (duration, moment, locale) {
            let template = Array(['fr'],['en']);

                template['fr'] =  "h [h] m [m]";
                template['en'] =  "h [h] m [m]";

            return moment.duration(duration).format(
                template[locale],
                {
                    usePlural: false,
                    round: false
                });
        },
        /**
         * Formate une date au format "Lundi 3 mai 2019"
         * https://momentjs.com/docs/#/displaying/format/
         * @param time
         * @param locale
         * @returns {*}
         */
        formatDateWithDayName: function (date, locale, withYear = true) {
            switch (locale) {
                case  'fr': // Dimanche 14 février 2010
                    if(withYear){
                        return this.$moment(date).format('ddd D MMM YYYY')
                    }else{
                        return this.$moment(date).format('ddd D MMM')
                    }

                case 'en': // Sunday, February 14th 2010
                default:
                    if(withYear) {
                        return this.$moment(date).format('ddd, MMM Do YYYY')
                    }
                    else{
                        return this.$moment(date).format('ddd, MMM Do')
                    }
            }

        },


        /**
         * Retourne true si date1 et date2 appartiennent au même jour (comparaison faites sur le début du jour)
         * @param date1   date (d'un timerecord au format de la bdd ex : 2021-06-22T08:00:00+00:00"
         * @param date2  date (d'un timerecord au format de la bdd ex : 2021-06-22T08:00:00+00:00"
         * @returns {boolean}
         */
        isSameDay(date1, date2) {

            let timezone = this.user.timezone;

            date1 = this.$moment(date1).tz(timezone).startOf('day')
            date2 = this.$moment(date2).tz(timezone).startOf('day')

            // si date (dateTr.startOfDay == todayTimezone.startofDay alors today
            if (date1.format() == date2.format()) {
                return true
            } else {
                return false
            }

        },
    },
}

export default TimeMixin;
